"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSteps = exports.ActionButtons = exports.StepWrapper = exports.SkipOrSaveButton = exports.WizardStepWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
const styled_breakpoints_1 = require("styled-breakpoints");
exports.WizardStepWrapper = styled_components_1.default.div `
	min-height: 550px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;

	${(0, styled_breakpoints_1.down)('sm')} {
		min-height: auto;
		padding-bottom: 3rem;
	}
`;
exports.SkipOrSaveButton = (0, styled_components_1.default)(elements_1.Button) `
	margin: 1.5rem 0.5rem;

	${(0, styled_breakpoints_1.down)('sm')} {
		margin: 0.5rem;
	}
`;
exports.StepWrapper = (0, styled_components_1.default)(elements_1.Steps.Step) `
	cursor: ${({ disabled }) => disabled && 'default'};

	:hover {
		.ant-steps-item-icon {
			background-color: ${({ disabled, theme }) => !disabled && theme.color.brand1};
		}
		.ant-steps-icon {
			color: ${({ disabled, theme }) => !disabled && theme.color.white} !important;
		}
	}
`;
exports.ActionButtons = styled_components_1.default.div `
	${(0, styled_breakpoints_1.down)('sm')} {
		display: flex;
	}
`;
exports.StyledSteps = (0, styled_components_1.default)(elements_1.Steps) `
	padding: 2rem;
	${(0, styled_breakpoints_1.only)('xs')} {
		padding: 5rem 1rem 1rem;
	}
`;
